import React, { useEffect, useState } from "react";
import MonthLetterDatePicker from "./Component/MonthLetterDatePicker";
import {
  useAddCustomerAppointmentMutation,
  useGetCustomerAppointmentByCustomerIdQuery,
  useUpdateCustomerAppointmentMutation,
} from "../../../Service/CustomerAppointment";
import { useDispatch, useSelector } from "react-redux";
import { updateCustomerAppointmentDetail } from "../../../store/reducers/digitalmarketing/customer";
import { specialChractorValidation } from "./Utils/validation";
import DatePicker from "react-datepicker";
// import '../../../../assets/DigitalMarketing/Css/Style.css'
import "react-datepicker/dist/react-datepicker.css";
import MonthLetterTimePicker from "./Component/MonthLetterTimePicker";
import { Button } from "@mui/material";
import { TiTick } from "react-icons/ti";
import moment from "moment";
import { useGetAppoinmentLeadbyIdQuery } from "../../../Service/appoinment";
function CustomerAppointment(props) {
  const { id, callBackforErrorMessage, openSnackBar,currentStage } = props;
  const dispatch = useDispatch();
  const [addCustomerAppointment] = useAddCustomerAppointmentMutation();
  const [updateCustomerAppointment] = useUpdateCustomerAppointmentMutation();
  const regex = /^\/(?:lead-management\/customer\/(\d+)|customer\/(\d+))$/;
  const path = window.location.pathname;
  
  const match = path.match(regex);
// console.log(match);

  const CustomerDetail = useSelector(
    (state: any) => state.customer.customerDetail
  );
  const { data: CurrentAppointment,refetch:refetchcurrentstage } = useGetAppoinmentLeadbyIdQuery({id:id||CustomerDetail.id} ,{
    refetchOnMountOrArgChange: true,
  });
  // console.log(CurrentAppointment);
  
  const CustomerAppointmentDetail = useSelector(
    (state: any) => state.customer.customerAppointment
  );
// console.log(CustomerAppointmentDetail);
  const account = useSelector((state: any) => state.auth);
  
  return (
    <>
      {CurrentAppointment && CurrentAppointment[0] && CurrentAppointment[0].customerId && (
        <>
          <li>
            <div className="mb-2">
              <span className="title">Appointment</span>
            </div>
          </li>
          <li className="mt-3">
            <span className="sub-title">Next Clinical Appointment On</span>
          </li>
          {/* {account.permissions.ivf_journey_status===1 && CustomerAppointmentDetail.reason && (  <div><div className="current-stage">{CustomerAppointmentDetail.reason}</div></div>)} */}
          <li className="date d-flex justify-content-between">
            <div>
              <img
                src={require(`../../../assets/DigitalMarketing/image/customer/apoinment/date.png`)}
                alt="i"
                width={15}
              />
              <p className="mb-0 mt-1 ms-4">
                {moment(CurrentAppointment[0]?.appointmentDate).format(
                  "DD-MM-YYYY"
                )}
              </p>
            </div>
            <div style={{ width: "125px" }}>
              <img
                src={require(`../../../assets/DigitalMarketing/image/customer/apoinment/clock.png`)}
                alt="i"
                width={15}
              />
              <p className="mb-0 mt-1 ms-4">
                {CurrentAppointment[0]?.appointmentTime}
              </p>
            </div>
          </li>
        </>
      )}
    </>
  );
}

export default React.memo(CustomerAppointment);
